import React from 'react';
import { createPortal } from 'react-dom';
import './BlockDatesModal.css';

const BlockDatesModal = ({
  open,
  onClose,
  properties = [],
  units = [],
  loadingUnits = false,
  form,
  onFormChange,
  onSubmit,
  submitting = false,
  error = '',
}) => {
  if (!open || typeof document === 'undefined') return null;

  const handleField = (field) => (e) => {
    onFormChange((prev) => ({ ...prev, [field]: e.target.value }));
  };

  return createPortal(
    <div
      className="ab-modal-overlay block-dates-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Block dates"
      onClick={onClose}
    >
      <div className="ab-modal block-dates-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ab-modal__title">Block dates</div>
        <p className="ab-modal__message">
          Mark dates as unavailable on a unit so guests cannot book them (e.g. phone reservation or maintenance).
        </p>

        {error && (
          <div className="airbnb-bookings-view__banner airbnb-bookings-view__banner--error" role="alert">
            {error}
          </div>
        )}

        <form
          className="ab-form block-dates-modal__form"
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          <label className="ab-form__label">
            Property
            <select
              className="ab-form__input"
              value={form.propertyId}
              onChange={(e) => onFormChange((prev) => ({ ...prev, propertyId: e.target.value, unitId: '' }))}
              disabled={submitting}
              required
            >
              {properties.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name || p.id}
                </option>
              ))}
            </select>
          </label>

          <label className="ab-form__label">
            Unit
            <select
              className="ab-form__input"
              value={form.unitId}
              onChange={handleField('unitId')}
              disabled={submitting || loadingUnits}
              required
            >
              <option value="">{loadingUnits ? 'Loading units…' : 'Select unit'}</option>
              {units.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                  {u.status ? ` (${u.status})` : ''}
                </option>
              ))}
            </select>
          </label>

          <div className="block-dates-modal__dates-row">
            <label className="ab-form__label">
              Start date
              <input
                className="ab-form__input"
                type="date"
                value={form.startDate}
                onChange={handleField('startDate')}
                disabled={submitting}
                required
              />
            </label>
            <label className="ab-form__label">
              End date
              <input
                className="ab-form__input"
                type="date"
                value={form.endDate}
                onChange={handleField('endDate')}
                min={form.startDate || undefined}
                disabled={submitting}
                required
              />
            </label>
          </div>

          <label className="ab-form__label">
            Reason (optional)
            <textarea
              className="ab-form__input block-dates-modal__reason"
              rows={3}
              placeholder="e.g. Reserved by phone"
              value={form.reason}
              onChange={handleField('reason')}
              disabled={submitting}
              maxLength={500}
            />
          </label>

          <div className="ab-modal__actions block-dates-modal__actions">
            <button
              type="button"
              className="airbnb-bookings-view__button airbnb-bookings-view__button--ghost"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="airbnb-bookings-view__button airbnb-bookings-view__button--danger"
              disabled={submitting}
            >
              {submitting ? 'Blocking…' : 'Block dates'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default BlockDatesModal;
